import {
  GeckoAnnularRing,
  GeckoAnnularRingWeldLine,
  GeckoCircumferentialWeld,
  GeckoCoatingRegion,
  GeckoComponentModelType,
  GeckoCone,
  GeckoConeCircumferentialWeld,
  GeckoConeCourse,
  GeckoConeRadialWeld,
  GeckoConicalPlate,
  GeckoDome,
  GeckoDomeWall,
  GeckoEllipsoidalHead,
  GeckoFeatureModelType,
  GeckoFixedSensor,
  GeckoFlatCircularFloor,
  GeckoGenericHeadCircumferentialWeld,
  GeckoGenericHeadRadialWeld,
  GeckoHemisphericalHead,
  GeckoHoodBend,
  GeckoHoodStraight,
  GeckoHorizontalTankShell,
  GeckoHorizontalWeld,
  GeckoLaunchTube,
  GeckoLeakDetectionValve,
  GeckoLegacyBoilerRepairRegion,
  GeckoLegacyBoilerWall,
  GeckoLegacyBoilerWalls,
  GeckoLegacyCone,
  GeckoLegSupport,
  GeckoLinerRegion,
  GeckoMachinedForgingSimple,
  GeckoManway,
  GeckoNozzle,
  GeckoPipeEccentricReducer,
  GeckoPipeElbow,
  GeckoPipeIntegralSupport,
  GeckoPipeNonIntegralSupport,
  GeckoPipeSection,
  GeckoPipeTJoint,
  GeckoPipeWrap,
  GeckoPlate,
  GeckoPolygonalPlate,
  GeckoPressureVesselShell,
  GeckoRectangularManway,
  GeckoSaddleSupport,
  GeckoSeamWeld,
  GeckoShellCourse,
  GeckoShipDeck,
  GeckoShipDeckBitt,
  GeckoShipDeckBulkhead,
  GeckoShipDeckChock,
  GeckoShipDeckCoaming,
  GeckoShipDeckCompartment,
  GeckoShipDeckDoor,
  GeckoShipDeckDrain,
  GeckoShipDeckHatch,
  GeckoShipDeckLadder,
  GeckoShipDeckLocker,
  GeckoShipHull,
  GeckoSkirtSupport,
  GeckoSphereFlatCap,
  GeckoSphericalPlate,
  GeckoTankFlatRoof,
  GeckoTankFloor,
  GeckoTorisphericalHead,
  GeckoTubePlate,
  GeckoVerticalTankFoundation,
  GeckoVerticalTankShell,
  GeckoVerticalWeld,
} from 'types'

/**
 * This mapping provides a connection between the RAM Component enum, and the class that represents it. This allows us
 * to dynamically retrieve the class for instantiation, form fields, etc.
 */
export const AssetModelComponentClassMap = new Map(
  Object.entries({
    [GeckoComponentModelType.VerticalTankShell]: GeckoVerticalTankShell,
    [GeckoComponentModelType.HorizontalTankShell]: GeckoHorizontalTankShell,
    [GeckoComponentModelType.TankFloor]: GeckoTankFloor,
    [GeckoComponentModelType.TankFlatRoof]: GeckoTankFlatRoof,
    [GeckoComponentModelType.PipeSection]: GeckoPipeSection,
    [GeckoComponentModelType.PipeElbow]: GeckoPipeElbow,
    [GeckoComponentModelType.PipeTJoint]: GeckoPipeTJoint,
    [GeckoComponentModelType.PipeEccentricReducer]: GeckoPipeEccentricReducer,
    [GeckoComponentModelType.ShipDeck]: GeckoShipDeck,
    [GeckoComponentModelType.BasicShipHull]: GeckoShipHull,
    [GeckoComponentModelType.LegacyBoilerWalls]: GeckoLegacyBoilerWalls,
    [GeckoComponentModelType.LegacyCone]: GeckoLegacyCone,
    [GeckoComponentModelType.Cone]: GeckoCone,
    [GeckoComponentModelType.LaunchTube]: GeckoLaunchTube,
    [GeckoComponentModelType.Dome]: GeckoDome,
    [GeckoComponentModelType.DomeWall]: GeckoDomeWall,
    [GeckoComponentModelType.FlatCircularFloor]: GeckoFlatCircularFloor,
    [GeckoComponentModelType.VerticalTankFoundation]:
      GeckoVerticalTankFoundation,
    [GeckoComponentModelType.MachinedForgingSimple]: GeckoMachinedForgingSimple,
    [GeckoComponentModelType.PressureVesselShell]: GeckoPressureVesselShell,
    [GeckoComponentModelType.HemisphericalHead]: GeckoHemisphericalHead,
    [GeckoComponentModelType.EllipsoidalHead]: GeckoEllipsoidalHead,
    [GeckoComponentModelType.TorisphericalHead]: GeckoTorisphericalHead,
    [GeckoComponentModelType.SphereFlatCap]: GeckoSphereFlatCap,
    [GeckoComponentModelType.HoodStraight]: GeckoHoodStraight,
    [GeckoComponentModelType.HoodBend]: GeckoHoodBend,
  })
)

/**
 * This mapping provides a connection between the RAM Feature enum and the class that represents it. This allows us to
 * dynamically retrieve a class for instantiate, form fields, etc.
 */
export const AssetModelFeatureClassMap = new Map(
  Object.entries({
    [GeckoFeatureModelType.Course]: GeckoShellCourse,
    [GeckoFeatureModelType.Plate]: GeckoPlate,
    [GeckoFeatureModelType.TubePlate]: GeckoTubePlate,
    [GeckoFeatureModelType.VerticalWeld]: GeckoVerticalWeld,
    [GeckoFeatureModelType.HorizontalWeld]: GeckoHorizontalWeld,
    [GeckoFeatureModelType.ConeCircumferentialWeld]:
      GeckoConeCircumferentialWeld,
    [GeckoFeatureModelType.ConeRadialWeld]: GeckoConeRadialWeld,
    [GeckoFeatureModelType.Manway]: GeckoManway,
    [GeckoFeatureModelType.RectangularManway]: GeckoRectangularManway,
    [GeckoFeatureModelType.Nozzle]: GeckoNozzle,
    [GeckoFeatureModelType.LeakDetectionValve]: GeckoLeakDetectionValve,
    [GeckoFeatureModelType.FixedSensor]: GeckoFixedSensor,
    [GeckoFeatureModelType.ShipDeckCompartment]: GeckoShipDeckCompartment,
    [GeckoFeatureModelType.ShipDeckBitt]: GeckoShipDeckBitt,
    [GeckoFeatureModelType.ShipDeckCoaming]: GeckoShipDeckCoaming,
    [GeckoFeatureModelType.ShipDeckChock]: GeckoShipDeckChock,
    [GeckoFeatureModelType.ShipDeckHatch]: GeckoShipDeckHatch,
    [GeckoFeatureModelType.ShipDeckLocker]: GeckoShipDeckLocker,
    [GeckoFeatureModelType.ShipDeckLadder]: GeckoShipDeckLadder,
    [GeckoFeatureModelType.ShipDeckBulkhead]: GeckoShipDeckBulkhead,
    [GeckoFeatureModelType.ShipDeckDoor]: GeckoShipDeckDoor,
    [GeckoFeatureModelType.ShipDeckDrain]: GeckoShipDeckDrain,
    [GeckoFeatureModelType.LegacyBoilerWall]: GeckoLegacyBoilerWall,
    [GeckoFeatureModelType.SeamWeld]: GeckoSeamWeld,
    [GeckoFeatureModelType.CircumferentialWeld]: GeckoCircumferentialWeld,
    [GeckoFeatureModelType.GenericHeadCircumferentialWeld]:
      GeckoGenericHeadCircumferentialWeld,
    [GeckoFeatureModelType.GenericHeadRadialWeld]: GeckoGenericHeadRadialWeld,
    [GeckoFeatureModelType.PipeNonIntegralSupport]: GeckoPipeNonIntegralSupport,
    [GeckoFeatureModelType.PipeIntegralSupport]: GeckoPipeIntegralSupport,
    [GeckoFeatureModelType.PipeWrap]: GeckoPipeWrap,
    [GeckoFeatureModelType.ConeCourse]: GeckoConeCourse,
    [GeckoFeatureModelType.ConePlate]: GeckoConicalPlate,
    [GeckoFeatureModelType.LegacyBoilerRepairRegion]:
      GeckoLegacyBoilerRepairRegion,
    [GeckoFeatureModelType.PolygonalPlate]: GeckoPolygonalPlate,
    [GeckoFeatureModelType.CoatingRegion]: GeckoCoatingRegion,
    [GeckoFeatureModelType.SphericalPlate]: GeckoSphericalPlate,
    [GeckoFeatureModelType.LinerRegion]: GeckoLinerRegion,
    [GeckoFeatureModelType.AnnularRing]: GeckoAnnularRing,
    [GeckoFeatureModelType.AnnularRingWeldLine]: GeckoAnnularRingWeldLine,
    [GeckoFeatureModelType.SkirtSupport]: GeckoSkirtSupport,
    [GeckoFeatureModelType.SaddleSupport]: GeckoSaddleSupport,
    [GeckoFeatureModelType.LegSupport]: GeckoLegSupport,
  })
)
